"use client";

import { userAuth } from "@/auth/actions";
import classNames from "classnames";
import { Session } from "next-auth";
import Link from "next/link";
import { useEffect, useState, useTransition } from "react";
import { PiUser } from "react-icons/pi";

export function MyPageLink() {
  const [session, setSession] = useState<Session | null>(null);
  const [isPending, startTransition] = useTransition();
  useEffect(() => {
    startTransition(async () => {
      const session = await userAuth();
      setSession(session);
    });
  }, []);
  return (
    <Link
      href="/min-side"
      className={classNames(
        "text-sm transition-opacity",
        isPending ? "opacity-0" : "opacity-100",
      )}
    >
      <PiUser className="inline" size={24} />
      {session ? "Min side" : "Logg inn"}
    </Link>
  );
}
